// Import lit-html functions
import { LitElement } from 'lit-element';

export class LightElement extends LitElement {
    createRenderRoot() {
        // Skip Shadow DOM Generation Shadow DOM
        return this;
    }
}
